import styled from "styled-components";

export const AppDiv = styled.div``;
